export const FETCH_WALLET: string = "connect_metamask";
